import TemplateVerdictTable from './TemplateVerdictTable';
const meta = {
    title: 'Features/Settings/Integrations/TceTemplateDiagnostic/TemplateVerdictTable',
    component: TemplateVerdictTable,
    parameters: {
        layout: 'padded'
    }
};
export default meta;
export const Default = {
    args: {
        templates: [
            {
                templateId: 115,
                childType: 'Long Form',
                name: 'L - (Annual) Fire Sprinkler',
                kept: false,
                reason: 'No long form template is enabled for template ID 115.'
            },
            {
                templateId: 367,
                childType: 'Repair Form',
                name: 'R - 5 Year Sprinkler Repair',
                kept: false,
                reason: 'Inspect Point cannot submit "Repair Form" forms.'
            },
            {
                templateId: 190,
                childType: 'Short Form',
                name: 'S - (Annual) Fire Sprinkler',
                kept: true,
                reason: 'Short forms are always offered.'
            }
        ]
    }
};
export const Empty = {
    args: { templates: [] }
};
